import { render, staticRenderFns } from "./px-information-card.vue?vue&type=template&id=29761103&scoped=true&"
import script from "./px-information-card.vue?vue&type=script&lang=ts&"
export * from "./px-information-card.vue?vue&type=script&lang=ts&"
import style0 from "./px-information-card.vue?vue&type=style&index=0&id=29761103&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29761103",
  null
  
)

export default component.exports